import { Injectable } from "@angular/core";

import { CommonState } from "../state";

import { CashDesksByCity } from "./cash-desk.model";

@Injectable({
	providedIn: "root",
})
export class CashDeskSelector {
	get() {
		return (state: CommonState): CashDesksByCity => state.cashDesk.cashDesks;
	}

	isBusy() {
		return (state: CommonState): boolean => state.cashDesk.isBusy;
	}
}
